/*
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  ここで配列等を宣言 (定数)
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/

const c_limit_category_sort_array = {
  全リミット: "全リミット",
  リミット3: "リミット3",
  リミット2: "リミット2",
  リミット1: "リミット1",
  禁止: "禁止"
};

const c_legend_sort_array = {
  LEGEND: "LEGEND"
};

const c_deck_disp_sort_array = {
  一覧表示: "一覧表示",
  一覧非表示: "一覧非表示"
};

const c_rarity_array = ["UR", "SR", "R", "N", "未実装"];

const c_monster_type1_array = ["-", "通常", "効果"];

const c_monster_type2_array = ["-", "フュージョン", "マキシマム"];

const c_support_type_array = ["-", "通常", "フィールド", "装備"];

// 現状レジェンドしか入りませんが、今後増えた時のために配列にしてます
const c_legend_array = ["-", "LEGEND"];

const c_attr_array = ["闇", "光", "地", "水", "炎", "風", "神", "魔法", "罠"];

const c_evaluation_st_array = [
  "-",
  "環境上位",
  "環境中堅",
  "環境下位",
  "その他",
  "ファンデッキ"
];

const c_evaluation_ty_array = [
  "-",
  "ビート系",
  "バーン系",
  "ワンキル系",
  "ロマン系"
];

const c_evaluation_df_array = ["-", "★5", "★4", "★3", "★2", "★1"];

export const Config = {
  limit_category_sort_array: c_limit_category_sort_array,
  legend_sort_array: c_legend_sort_array,
  deck_disp_sort_array: c_deck_disp_sort_array,
  rarity_array: c_rarity_array,
  monster_type1_array: c_monster_type1_array,
  monster_type2_array: c_monster_type2_array,
  support_type_array: c_support_type_array,
  legend_array: c_legend_array,
  attr_array: c_attr_array,
  evaluation_st: c_evaluation_st_array,
  evaluation_ty: c_evaluation_ty_array,
  evaluation_df: c_evaluation_df_array
};

/*
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  ここで関数を定義
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/

//---------------------------
// 改行コード→br
//---------------------------
export function newlinesToBr(text) {
  return text.replace(/\r\n|\r|\n/g, "<br>");
}

//---------------------------
// br→改行コード
//---------------------------
export function brToNewlines(text) {
  return text.replace(/<br\s*\/?>/g, "\n");
}

//---------------------------
// 評価テキスト系にタグ挿入
//---------------------------
export function insertHtmlTag(text) {
  var text_arr = text.split(/\r\n|\r|\n/);
  var pattern = /^<h[2-6]>(.*?)<\/h[2-6]>$/i;
  var output_text = "";
  text_arr.forEach(value => {
    if (pattern.test(value)) {
      output_text += value;
    } else if (value != "") {
      output_text += "<p>" + value + "</p>";
    }
  });

  return output_text;
}

//---------------------------
// 評価テキスト系のタグ削除
//---------------------------
export function delHtmlTag(text) {
  var tmp_text_arr = [];
  var text_arr = [];
  var pattern = /<(p|h[2-6])>(.*?)<\/\1>/g;
  var pattern2 = /^<h[2-6]>(.*?)<\/h[2-6]>$/i;

  while ((tmp_text_arr = pattern.exec(text)) !== null) {
    if (pattern2.test(tmp_text_arr[0])) {
      // hタグの場合はタグを入れる
      text_arr.push(tmp_text_arr[0]);
    } else {
      // タグで囲われた内容を取得して配列に格納
      text_arr.push(tmp_text_arr[2]);
    }
  }

  var output_text = "";
  if (text_arr.length > 0) {
    output_text = text_arr.join("<br>");
    output_text = brToNewlines(output_text);
  } else if (text.length > 0) {
    output_text = text;
  }

  return output_text;
}
